import { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import {
  B2cAccessForbiddenComponent,
  B2cUserNotFoundComponent,
  PageForbiddenComponent,
  PageNotFoundComponent,
  RegisterGuestComponent,
  LayoutWrapperComponent,
  PageInternalServerErrorComponent,
} from '@shared/feature/page-layout';
import { DownloadClientComponent } from '@shared/ui/static-page';
import { DownloadClientGuard, RoleGuard } from '@intrensic/shared/guards';

export const webRoutes: Route[] = [
  {
    path: '',
    component: LayoutWrapperComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        loadChildren: async () => (await import('@intrensic/evidence-management/feature')).IntrensicEvidenceManagementFeatureModule,
        canActivateChild: [RoleGuard],
      },
      {
        path: '',
        loadChildren: async () => (await import('@intrensic/agency-management/feature')).IntrensicAgencyManagementModule,
        canActivateChild: [RoleGuard],
      },
      {
        path: '',
        loadChildren: async () => (await import('@intrensic/cases-management/feature')).IntrensicCasesManagementFeatureModule,
        canActivateChild: [RoleGuard],
      },
      {
        path: '',
        loadChildren: async () => (await import('@intrensic/events-management/feature')).IntrensicEventsManagementFeatureModule,
        canActivate: [RoleGuard],
      },
      {
        path: '',
        loadChildren: async () => (await import('@intrensic/dashboard/feature')).IntrensicDashboardFeatureModule,
        canActivateChild: [RoleGuard],
      },
      {
        path: 'downloads',
        component: DownloadClientComponent,
        canActivate: [DownloadClientGuard],
      },
    ],
  },
  {
    path: 'Error',
    component: PageNotFoundComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'Error/403',
    component: PageForbiddenComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'forbidden',
    component: B2cAccessForbiddenComponent,
  },
  {
    path: 'user-not-found',
    component: B2cUserNotFoundComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'Error/InternalServer',
    component: PageInternalServerErrorComponent,
    canActivate: [MsalGuard],
  },
  {
    path: 'register',
    component: RegisterGuestComponent,
  },
  {
    path: '**',
    redirectTo: 'Error',
  },
];
